import axios from 'axios'

/**
 * @desc Fetch All Credit Returns for Supplier
 * @desc API fetchCreditReturnsForSupplierAndStatus in BFF
 * @param {Integer} supplierId - supplierId
 * @param {Array} status - 'ACCEPTED', 'OUTSTANDING', 'PROCESSED', 'REJECTED'
 * @param {String} query - Includes several search parameters
 */
export const fetchCreditReturns = (
  supplierId,
  page,
  size,
  status = [],
  query
) => {
  let baseQuery = `supplierId=${supplierId}&page=${page}&size=${size}&status=${status}`
  if (query) baseQuery += `&${query}`

  return axios
    .get(`/authenticated/credit-return?${baseQuery}`)
    .then((res) => res.data)
}

/**
 * @desc Fetch Credit Return Details
 * @desc API getCreditReturnById in BFF
 */
export const fetchCreditReturn = (id) =>
  axios.get(`/authenticated/credit-return/${id}`).then((res) => res.data)

/**
 * @desc Finalise Credit Return
 * @desc API finaliseCreditReturn in BFF
 */
export const finaliseCreditReturn = (id, request) =>
  axios
    .put(`/authenticated/credit-return/${id}/finalise`, request)
    .then((res) => res.data)

/**
 * @desc Approve an individual Credit Return item
 * @desc API approveCreditReturnItem in BFF
 */
export const approveCreditReturnItem = (id, itemId) =>
  axios
    .put(`/authenticated/credit-return/${id}/items/${itemId}/approve`)
    .then((res) => res.data)

/**
 * @desc Reject an individual Credit Return item
 * @desc API rejectCreditReturnItem in BFF
 */
export const rejectCreditReturnItem = (id, itemId) =>
  axios
    .put(`/authenticated/credit-return/${id}/items/${itemId}/reject`)
    .then((res) => res.data)

/**
 * @desc Fetch CreditReturn PDF
 * @desc getCreditNotePdfUrl in BFF
 */
export const fetchCreditReturnPdfUrl = (creditReturnId) =>
  axios
    .get(`/authenticated/credit-return/${creditReturnId}/credit-note`)
    .then((res) => res.data)

export const fetchCreditReturnInvoicePdfUrl = (creditReturnId) =>
  axios
    .get(`/authenticated/credit-return/${creditReturnId}/pdf/invoice/url`)
    .then((res) => res.data)

/**
 * @desc Fetches Credit Returns Statistics
 * @desc API getQueryStatusStatistics in BFF
 */
export const fetchCreditReturnsStatusStatistics = () =>
  axios.get(`/authenticated/credit-return/statistics`).then((res) => res.data)
